import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { DistributionChannelResponse, DistributionChannelRequest, DistributionChannelsService } from '@src/app/shared/backend/clients';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-edit-distribution-channel',
    templateUrl: './edit-distribution-channel.component.html',
    styleUrl: './edit-distribution-channel.component.scss',
    host: {
        class: 'app-edit-distribution-channel'
    },
    standalone: false
})
export class EditDistributionChannelComponent extends BaseViewComponent implements OnInit  {

  distributionChannelId: number = 0;
  distributionChannel: DistributionChannelResponse = {};

  totalRecords: number = 0;
  rowsPerPageOption: number = 5;
  usersList: string[] = [];

  public distributionChannelForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    code: ['', [Validators.required, Validators.maxLength(50)]]
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private distributionChannelsService: DistributionChannelsService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
     this.route.params.subscribe(async params => {
      this.distributionChannelId = params['distributionChannelId'];

      if (this.distributionChannelId) {
        await this.getDistributionChannelId();
      }
    });
  }

  async getDistributionChannelId() {
      this.distributionChannel = await firstValueFrom(this.distributionChannelsService.apiDistributionChannelsIdGet(this.distributionChannelId));
      this.initForm();
  }

  initForm() {
    this.distributionChannelForm.controls['name'].setValue(this.distributionChannel.name);
    this.distributionChannelForm.controls['code'].setValue(this.distributionChannel.code);
  }

  async submitForm() {
    if (this.distributionChannelForm.valid) {

      const payload: DistributionChannelRequest = {
        name: this.distributionChannelForm.controls['name'].value,
        code: this.distributionChannelForm.controls['code'].value
      };

      await firstValueFrom(this.distributionChannelsService.apiDistributionChannelsUpdateIdPut(this.distributionChannelId, payload));

      this.router.navigate(['/distribution-channels', this.distributionChannelId]);
    }
  }
}
